import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

class AgregarConcurso extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
            checkAdd: false,
            llamado: {
                nombre: '',
                estado: '',
                fechaInicio: '',
                numeroUConcursa: '',
            },
            numeroLlamado: '',
            datosConsulta: [],
            estadosLlamados: [],
            datoEspecifico: {},
            modificar: false,
            consultaEspecifica: false,
            conEspecifica: {
                tipoConsulta: '',
            },

            todos: [],
            inscriptos: [],
            pendientes: [],
            aceptados: [],
            rechazados: [],
            inscriptosCondicional: [],
            especifica: false,
            datosInscripto: {},
            consultaInscripto: false,

            listInscriptos: {
                todos: true,
                pendientes: false,
                aceptados: false,
                rechazados: false,
                condicional: false,
            },
            
            //----------------Rechazo--------------
            rechazar: false,
            condicional: false,
            motivoRechazo: {
                texto: '',
            },
            //----------------Rechazo--------------
        }

        this.manejarCambiosDatosConsulta = this.manejarCambiosDatosConsulta.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
        this.llamadoAgregar = this.llamadoAgregar.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioAgregar = this.manejarEnvioAgregar.bind(this);
        this.manejarAtrasConsulta = this.manejarAtrasConsulta.bind(this);
        this.manejarModificar = this.manejarModificar.bind(this);
        this.manejarCambiosDatosEspecifico = this.manejarCambiosDatosEspecifico.bind(this);
        this.manejarVolverEspcifica = this.manejarVolverEspcifica.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.actList = this.actList.bind(this);
        this.manejarConsultaEspecifica = this.manejarConsultaEspecifica.bind(this);
        this.manejarCambiosDatosConsultaEsp = this.manejarCambiosDatosConsultaEsp.bind(this);
        this.manejarEnvioConsultaConcurso = this.manejarEnvioConsultaConcurso.bind(this);
        this.manejarAtrasConsultaEspe = this.manejarAtrasConsultaEspe.bind(this);
        this.manejarConsultaInscripto = this.manejarConsultaInscripto.bind(this);
        this.manejarEspcificaAceptar = this.manejarEspcificaAceptar.bind(this);
        this.inscripcionListar = this.inscripcionListar.bind(this);
        this.manejarVolverEspcificaInsripto = this.manejarVolverEspcificaInsripto.bind(this);
        this.manejarEspcificaRechazar = this.manejarEspcificaRechazar.bind(this);
        this.manejarCambiosDatosRechazar = this.manejarCambiosDatosRechazar.bind(this);
        this.manejarVolverRechazo = this.manejarVolverRechazo.bind(this);
        this.manejarEnviarRechazo = this.manejarEnviarRechazo.bind(this);
        this.manejarEspcificaCondicional = this.manejarEspcificaCondicional.bind(this);
    }

    async componentDidMount(){
        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_estadoLlamados.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            estadosLlamados: datoDepartamento,
        });
    }

    render(){
        return (
            <>
                <h3>Concursos</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consultaRealizada || this.state.rechazar || this.state.condicional
                ?
                    null
                :
                    <FormControlLabel label='Agregar Llamado' control={<Checkbox checked={this.state.checkAdd} onChange={this.llamadoAgregar} id='add'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                }
                {this.state.consultaRealizada || this.state.checkAdd || this.state.rechazar || this.state.condicional
                ?
                    null
                :
                    <Container>
                        <br/>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>Número Llamado</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroLlamado' value={this.state.numeroLlamado} onChange={this.manejarCambiosDatosConsulta}/>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioConsulta}>Consultar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                }
                {this.state.consultaRealizada && (!this.state.modificar) && (!this.state.consultaEspecifica)
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número U. Concursa</StyledTableCell>
                                        <StyledTableCell>Número</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Estado Llamado</StyledTableCell>
                                        <StyledTableCell>Fecha Inicio</StyledTableCell>
                                        <StyledTableCell>Fecha Fin</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {this.state.datosConsulta.map((name) => (
                                    <StyledTableRow key={name.idLlamados}>
                                        <StyledTableCell>{name.numeroUConcursa}</StyledTableCell>
                                        <StyledTableCell>{name.idLlamados}</StyledTableCell>
                                        <StyledTableCell>{name.nombreLlamado}</StyledTableCell>
                                        <StyledTableCell>{name.estadoLlamado}</StyledTableCell>
                                        <StyledTableCell>{name.fechaInicio}</StyledTableCell>
                                        <StyledTableCell>{name.fechaFin}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarConsultaEspecifica(name)}>Consultar</button></StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModificar(name)}>Modificar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <button className="btn btn-outline-success mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasConsulta}>Volver</button>
                    </Container>
                :
                    null
                }
                {this.state.checkAdd
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número U. Concursa</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Estado</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroUConcursa' value={this.state.llamado.numeroUConcursa} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='nombre' value={this.state.llamado.nombre} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='estado' value={this.state.llamado.estado} onChange={this.manejarCambiosDatos} >
                                                <option value=''></option>
                                                {this.state.estadosLlamados.map((name) =>
                                                    <option
                                                    key={name.idEstadoLlamado}
                                                    value={name.idEstadoLlamado}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioAgregar}>Agregar</button></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                :
                    null
                }
                {this.state.modificar
                ?
                    <Container>
                        <br/>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Número U. Concursa</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroUConcursa' value={this.state.datoEspecifico.numeroUConcursa} onChange={this.manejarCambiosDatosEspecifico}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Número</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.idLlamados}
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Nombre</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='nombreLlamado' value={this.state.datoEspecifico.nombreLlamado} onChange={this.manejarCambiosDatosEspecifico}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Estado</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='estadoCodigo' value={this.state.datoEspecifico.estadoCodigo} onChange={this.manejarCambiosDatosEspecifico} >
                                        <option value=''></option>
                                        {this.state.estadosLlamados.map((name) =>
                                            <option
                                            key={name.idEstadoLlamado}
                                            value={name.idEstadoLlamado}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Fecha Inicio</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.fechaInicio}
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Fecha Fin</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.fechaFin}
                                </Grid>
                            </Grid>
                        </Box>
                        <br/>
                        <button className="btn btn-outline-success mx-2" type='button' onClick={this.manejarVolverEspcifica}>Volver</button>
                        <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                    </Container>
                :
                    null
                }
                {this.state.consultaEspecifica && (!this.state.especifica) && (!this.state.consultaInscripto)
                ?
                    <Container>
                        <br/>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>Tipo Consulta</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoConsulta' value={this.state.conEspecifica.tipoConsulta} onChange={this.manejarCambiosDatosConsultaEsp} >
                                        <option value=''></option>
                                        <option value={1}>Inscriptos</option>
                                        {/*<option value={2}>Listar Inscriptos (Excel)</option>*/}
                                    </select>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioConsultaConcurso}>Consultar</button>
                                </Grid>
                            </Grid>
                        </Box>
                        <br/>
                        <button className="btn btn-outline-success mx-2" type='button' onClick={this.manejarVolverEspcifica}>Volver</button>
                    </Container>
                :
                    null
                }
                {this.state.especifica
                ?
                    <Container>
                        <FormControlLabel label='TODOS' control={<Checkbox checked={this.state.listInscriptos.todos} onChange={this.inscripcionListar} id='todos'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='PENDIENTES' control={<Checkbox checked={this.state.listInscriptos.pendientes} onChange={this.inscripcionListar} id='pendientes'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='ACEPTADOS' control={<Checkbox checked={this.state.listInscriptos.aceptados} onChange={this.inscripcionListar} id='aceptados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='RECHAZADOS' control={<Checkbox checked={this.state.listInscriptos.rechazados} onChange={this.inscripcionListar} id='rechazados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='CONDICIONAL' control={<Checkbox checked={this.state.listInscriptos.condicional} onChange={this.inscripcionListar} id='condicional'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    </Container>
                :
                    null
                }
                {this.state.especifica
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número Llamado</StyledTableCell>
                                        <StyledTableCell>C.I.</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Email</StyledTableCell>
                                        <StyledTableCell>Inscripción</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {this.state.inscriptos.map((name) => (
                                    <StyledTableRow key={name.idPersonaLlamado}>
                                        <StyledTableCell>{name.llamado}</StyledTableCell>
                                        <StyledTableCell>{name.ci}</StyledTableCell>
                                        <StyledTableCell>{name.nombre}</StyledTableCell>
                                        <StyledTableCell>{name.email}</StyledTableCell>
                                        <StyledTableCell>{name.estadoInscripcion}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarConsultaInscripto(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <button className="btn btn-outline-success mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasConsultaEspe}>Volver</button>
                    </Container>
                :
                    null
                }
                {this.state.consultaInscripto
                ?
                    <Container>
                        <br/>
                        <fieldset>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Llamado</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <h4>{this.state.datoEspecifico.nombreLlamado}</h4>
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </fieldset>
                        <fieldset>
                            <legend>Datos Personales</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Primer Nombre</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datosInscripto.pNombre}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Segundo Nombre</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datosInscripto.sNombre}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Primer Apellido</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datosInscripto.pApellido}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Segundo Apellido</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datosInscripto.sApellido}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>C.I.</Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.ci}
                                        </Grid>
                                    <Grid item xs={2}>
                                        <Item>Fecha Nacimiento</Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.fNacimiento}
                                        </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Credencial</Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.credencialSerie + ' ' + this.state.datosInscripto.credencialNumero}
                                        </Grid>
                                    <Grid item xs={6}>
                                        {/*Estolo pongo para un salto de linea */}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Direccion</Item>
                                    </Grid>
                                        <Grid item xs={6}>
                                            {this.state.datosInscripto.direccion}
                                        </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Departamento </Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.departamento}
                                        </Grid>
                                    <Grid item xs={2}>
                                        <Item>Teléfono</Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.telefono}
                                        </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Celular </Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.celular}
                                        </Grid>
                                    <Grid item xs={2}>
                                        <Item>Carné De Salud</Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.carneSalud}
                                        </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Sexo </Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.sexo}
                                        </Grid>
                                    <Grid item xs={2}>
                                        <Item>Mail </Item>
                                    </Grid>
                                        <Grid item xs={2}>
                                            {this.state.datosInscripto.email}
                                        </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <fieldset style={{marginTop: '1rem'}}>
                            <legend>Estudios</legend>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Ciclo Basico </Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datosInscripto.cicloBasico}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Bachillerato </Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datosInscripto.bachillerato}
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Universidad </Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.datosInscripto.universidad}
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <fieldset>
                            <legend>Documentos</legend>
                            <TableContainer style={{width: '50%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                                <Table sx={{minWidth: 400}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Nombre Documento</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosInscripto.archivos.map((pdf, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{pdf.name}</StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf(pdf.name, pdf.data)}>Descargar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </fieldset>
                        <button className="btn btn-outline-success mx-2" style={{marginTop: '1rem'}} type='button' onClick={this.manejarVolverEspcificaInsripto}>Volver</button>
                        <button className="btn btn-outline-success mx-2" style={{marginTop: '1rem'}} type='button' onClick={this.manejarEspcificaAceptar}>Aceptar</button>
                        <button className="btn btn-outline-success mx-2" style={{marginTop: '1rem'}} type='button' onClick={this.manejarEspcificaRechazar}>Rechazar</button>
                        <button className="btn btn-outline-success mx-2" style={{marginTop: '1rem'}} type='button' onClick={this.manejarEspcificaCondicional}>Condicional</button>
                        <br/>
                    </Container>
                :
                    null
                }
                {this.state.rechazar || this.state.condicional
                ?
                    <Container>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={5}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Motivo Rechazo/Condicional</Item>
                                </Grid>
                            </Grid>
                        </Box>
                        <textarea style={{width:"100%", border:"2px solid #D6EAF8", marginTop: '1rem'}} rows={10} cols={40} id='texto' value={this.state.motivoRechazo.texto} onChange={this.manejarCambiosDatosRechazar}/>
                        <button className="btn btn-outline-success mx-2" style={{marginTop: '1rem'}} type='button' onClick={this.manejarVolverRechazo}>Cancelar</button>
                        <button className="btn btn-outline-success mx-2" style={{marginTop: '1rem'}} type='button' onClick={this.manejarEnviarRechazo}>Enviar</button>
                    </Container>
                :
                    null
                }
                <br/>
            </>
        )
    }

    async manejarCambiosDatosConsulta(e){
        e.preventDefault();
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            numeroLlamado: valor,
        })
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();
        this.setState({
            loading: true,
            errores: null,
            notificaciones: null,
        })
        const cargaUtil = JSON.stringify([this.state.numeroLlamado]);

        const control = await fetch(`${Constantes.RUTA_API}/consultar_llamado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                datosConsulta: res[1],
                errores: null,
                consultaRealizada: true,
            })
        }
    }

    llamadoAgregar(e){
        this.setState({
            errores: null,
            notificaciones: null,
            llamado: {
                nombre: '',
                estado: '',
                numeroUConcursa: '',
            },
        })
        if(this.state.checkAdd){
            this.setState({
                errores: false,
                notificaciones: false,
                checkAdd: false,
            })
        }else{
            this.setState({
                errores: false,
                notificaciones: false,
                checkAdd: true,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        })
        this.setState(state => {
            const movimientosActualizado = state.llamado;
            movimientosActualizado[clave] = valor;
            return{
                llamado: movimientosActualizado,
            };
        })
    }

    async manejarEnvioAgregar(e){
        e.preventDefault();
        this.setState({
            loading: true,
            errores: null,
            notificaciones: null,
        })
        const cargaUtil = JSON.stringify([this.state.llamado]);

        const control = await fetch(`${Constantes.RUTA_API}/agregar_llamado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Datos ingresados correctamente',
                llamado:{
                    nombre: '',
                    estado: '',
                    fechaInicio: '',
                    numeroUConcursa: '',
                },
            })
        }
    }

    manejarAtrasConsulta(e){
        e.preventDefault();

        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
            checkAdd: false,
            llamado: {
                nombre: '',
                estado: '',
                fechaInicio: '',
                numeroUConcursa: '',
            },
            numeroLlamado: '',
            datosConsulta: [],
        })
    }

    manejarModificar(dato){
        this.setState({
            notificaciones: null,
            errores: null,
            datoEspecifico: dato,
            modificar: true,
        })
    }

    manejarCambiosDatosEspecifico(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.datoEspecifico;
            movimientosActualizado[clave] = valor;
            return{
                datoEspecifico: movimientosActualizado,
            };
        })
    }

    manejarVolverEspcifica(e){
        e.preventDefault();

        this.setState({
            errores: null,
            notificaciones: null,
            datoEspecifico: {},
            modificar: false,
            consultaEspecifica: false,
        })
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.datoEspecifico]);

        const control = await fetch(`${Constantes.RUTA_API}/modificar_llamado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.actList();
            this.setState({
                errores: null,
                notificaciones: 'Datos ingresados correctamente',
                modificar: false,
                datoEspecifico: {},
            })
        }
    }

    async actList(e){
        const cargaUtil = JSON.stringify([this.state.numeroLlamado]);

        const control = await fetch(`${Constantes.RUTA_API}/consultar_llamado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                datosConsulta: res[1],
                errores: null,
                consultaRealizada: true,
            })
        }
    }

    manejarConsultaEspecifica(dato){
        this.setState({
            consultaEspecifica: true,
            datoEspecifico: dato,
            errores: null,
            notificaciones: null,
        })
    }

    manejarCambiosDatosConsultaEsp(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.conEspecifica;
            movimientosActualizado[clave] = valor;
            return{
                conEspecifica: movimientosActualizado,
            };
        })
    }

    async manejarEnvioConsultaConcurso(e){
        e.preventDefault();
        this.setState({
            loading: true,
            errores: null,
            notificaciones: null,
        })
        const cargaUtil = JSON.stringify([this.state.conEspecifica, this.state.datoEspecifico]);

        const control = await fetch(`${Constantes.RUTA_API}/consultar_tipoLlamado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                todos: res[1],
                inscriptos: res[1],
                pendientes: res[2],
                aceptados: res[3],
                rechazados: res[4],
                inscriptosCondicional: res[5],
                especifica: true,
            })
        }
    }

    manejarAtrasConsultaEspe(e){
        e.preventDefault();
        this.setState({
            especifica: false,
        })
    }

    manejarConsultaInscripto(dato){
        this.setState({
            especifica: false,
            datosInscripto: dato,
            consultaInscripto: true,
        })
    }

    async manejarEspcificaAceptar(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.datosInscripto]);

        const control = await fetch(`${Constantes.RUTA_API}/aceptar_inscripcion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Datos ingresados correctamente',
                consultaInscripto: false,
                datosInscripto: {},
            })
        }
    }

    async inscripcionListar(e){
        e.preventDefault();
        const clave = e.target.id;
        if(clave === 'todos'){
            this.setState({
                listInscriptos: {
                    todos: true,
                    pendientes: false,
                    aceptados: false,
                    rechazados: false,
                    condicional: false,
                },
                inscriptos: this.state.todos,
            });
        }else if(clave === 'pendientes'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: true,
                    aceptados: false,
                    rechazados: false,
                    condicional: false,
                },
                inscriptos: this.state.pendientes,
            })
        }else if(clave === 'aceptados'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: false,
                    aceptados: true,
                    rechazados: false,
                    condicional: false,
                },
                inscriptos: this.state.aceptados,
            })
        }else if(clave === 'rechazados'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: false,
                    aceptados: false,
                    rechazados: true,
                    condicional: false,
                },
                inscriptos: this.state.rechazados,
            })
        }else if(clave === 'condicional'){
            this.setState({
                listInscriptos: {
                    todos: false,
                    pendientes: false,
                    aceptados: false,
                    rechazados: false,
                    condicional: true,
                },
                inscriptos: this.state.inscriptosCondicional,
            })
        }
    }

    manejarVolverEspcificaInsripto(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            datosInscripto: {},
            consultaInscripto: false,
        })
    }

    manejarEspcificaRechazar(e){
        e.preventDefault();
        this.setState({
            rechazar: true,
            errores: null,
            notificaciones: null,
            consultaEspecifica: false,
            consultaInscripto: false,
            consultaRealizada: false,
        })
    }

    manejarCambiosDatosRechazar(e){
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.motivoRechazo;
            movimientosActualizado[clave] = valor;
            return{
                motivoRechazo: movimientosActualizado,
            };
        })
    }

    manejarVolverRechazo(e){
        e.preventDefault();
        this.setState({
            rechazar: false,
            errores: null,
            notificaciones: null,
            consultaEspecifica: true,
            consultaInscripto: true,
            consultaRealizada: true,
            condicional: false,
        })
    }

    async manejarEnviarRechazo(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.datosInscripto, this.state.motivoRechazo, this.state.condicional]);

        const control = await fetch(`${Constantes.RUTA_API}/rechazar_inscripcion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                notificaciones: 'Datos ingresados correctamente',
                errores: null,
                rechazar: false,
                condicional: false,
                motivoRechazo: {
                    texto: '',
                },
            })
        }
    }

    manejarEspcificaCondicional(e){
        e.preventDefault();
        this.setState({
            condicional: true,
            errores: null,
            notificaciones: null,
            consultaEspecifica: false,
            consultaInscripto: false,
            consultaRealizada: false,
        })
    }

}

export default AgregarConcurso